import { fetchQuery, graphql } from "react-relay";
import RelayEnvironment from "@phoenix/RelayEnvironment";
import { settingsAlertsPageLoaderQuery } from "./__generated__/settingsAlertsPageLoaderQuery.graphql";

export async function settingsAlertsPageLoader() {
  return await fetchQuery<settingsAlertsPageLoaderQuery>(
    RelayEnvironment,
    graphql`
      query settingsAlertsPageLoaderQuery {
        smtpConfig {
          host
          port
          username
          senderAddress
          recipientAddress
        }
        alertPreferences {
          piiEnabled
          costAlertEnabled
          costThreshold
          errorAlertEnabled
          systemHealthAlertEnabled
        }
        piiConfig {
          excludedEntities
        }
      }

    `,
    {}
  ).toPromise();
}
